import { AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";
import { BrowserRouter, Routes } from "react-router-dom";
import { ToastProvider } from "./components/ToastProvider";
import { msalInstance, apiRequest } from "./auth/msalConfig";
import { routeElements } from "./app/routes";

/**
 * Root component (task 5.2): the auth gate (`AuthenticatedTemplate`/
 * `UnauthenticatedTemplate`) is unchanged from before PR5. Everything it
 * used to render directly (nav, route table, `UserMenu`) now lives in
 * `AppShell`/`routes.tsx` — `App` only wires the declarative
 * `<BrowserRouter>`/`<Routes>` table (unchanged shape from before PR5; see
 * `routes.tsx` for why this stays a declarative router rather than
 * `createBrowserRouter`).
 */
export function App() {
  return (
    <>
      <AuthenticatedTemplate>
        <BrowserRouter>
          {/* panel-redesign-v3 T4 (REDISENO-PANEL.md §5.2): the campaign
              create modal navigates to the new draft's detail page and shows
              a toast — `useToast()` must be available anywhere under the
              router, not just inside one screen's own subtree. */}
          <ToastProvider>
            <Routes>{routeElements}</Routes>
          </ToastProvider>
        </BrowserRouter>
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        {/* REDISENO-PANEL.md §3.3: centered 400px card — logo, "Email
            Marketing B2B" (H1), the corporate-account subtitle, a
            full-width dark button with the Microsoft four-square mark, and
            a simpler "no access" footnote (replaces the previous "Panel de
            administración" heading and Entra ID/roles footnote). */}
        <section className="login-gate" aria-label="Acceso al panel">
          <div className="login-gate__card">
            <img
              className="login-gate__logo"
              src="/assets/logo-control-logistico.png"
              alt="Control Logístico"
            />
            <div>
              <h1>Email Marketing B2B</h1>
              <p>Ingresa con tu cuenta corporativa para continuar.</p>
            </div>
            <button type="button" onClick={() => void msalInstance.loginRedirect(apiRequest)}>
              <span className="login-gate__ms-logo" aria-hidden="true">
                <span />
                <span />
                <span />
                <span />
              </span>
              Iniciar sesión
            </button>
            <p className="login-gate__footnote">¿No tienes acceso? Pídelo al administrador de tu cuenta.</p>
          </div>
        </section>
      </UnauthenticatedTemplate>
    </>
  );
}

export default App;
